import TruncatedTextWithTooltip from '@/fsd/shared/ui/TruncatedTextWithTooltip/TruncatedTextWithTooltip';
import cx from 'classnames';
import AllBarcodes from '../AllBarcodes/all-barcodes';
import style from './ProductInfo.module.scss';

interface IParams {
  sku?: string;
  barcodes?: number[];
  vendorCode?: string;
  name?: string;
  className?: string;
  size?: number;
}

const ProductInfo = ({
  sku,
  barcodes,
  vendorCode,
  name,
  size,
  className,
}: IParams) => {
  return (
    <div className={cx(style.productInfo, className)}>
      <div className={style.productName}>
        <TruncatedTextWithTooltip
          className={style.productNameTooltip}
          text={name}
          maxLines={1}
        />
      </div>
      <div className={style.centerBox}>
        <div className={style.productArticle} data-testid="product-vendor-code">
          {vendorCode}
        </div>
        {size ? <div className={style.size}>Резмер: {size}</div> : <></>}
      </div>
      <div className={style.productSku} data-testid="product-sku">
        <AllBarcodes barcodes={barcodes} />{' '}
        {sku && (
          <>
            <span className={style.productSkuDesc}>SKU:</span> {sku}
          </>
        )}
      </div>
    </div>
  );
};

export default ProductInfo;
